import { useCallback, useEffect } from 'react'
import { TaskCreatedNotification } from 'types/pushNotifications'

type TaskCreatedEventListener = (event: TaskCreatedNotification) => void
const taskCreatedEventListeners = new Set<TaskCreatedEventListener>()

export const emitTaskCreatedEvent = (taskEvent: TaskCreatedNotification) => {
  taskCreatedEventListeners.forEach((listener) => listener(taskEvent))
}

export const useTaskCreatedEvent = (
  onTaskCreatedEvent: (taskEvent: TaskCreatedNotification) => void
) => {
  const handleTaskCreatedEvent = useCallback(
    (taskEvent: TaskCreatedNotification) => {
      onTaskCreatedEvent(taskEvent)
    },
    [onTaskCreatedEvent]
  )

  useEffect(() => {
    // Subscribe to task created
    taskCreatedEventListeners.add(handleTaskCreatedEvent)

    return () => {
      // Cleanup: Unsubscribe when component unmounts
      taskCreatedEventListeners.delete(handleTaskCreatedEvent)
    }
  }, [handleTaskCreatedEvent])
}
